// extracted by extract-css-chunks-webpack-plugin
module.exports = {"spinner-container":"shared-styles__spinner-container___1oOTc","spinnerContainer":"shared-styles__spinner-container___1oOTc","load-more-spinner":"shared-styles__load-more-spinner___181f1","loadMoreSpinner":"shared-styles__load-more-spinner___181f1","load-spinner":"shared-styles__load-spinner___WAjLs","loadSpinner":"shared-styles__load-spinner___WAjLs"};
    if(module.hot) {
      // 1750289816375
      var cssReload = require("../../../node_modules/extract-css-chunks-webpack-plugin/dist/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}","cssModules":true});
      module.hot.dispose(cssReload);
      ;
    }
  